import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { UnloadGuard } from 'src/app/core/guards/unload.guard';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { EmailsListComponent } from './emails-list/emails-list.component';

const routes: Routes = [
  {
    path: 'emails',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [{ path: '', component: EmailsListComponent }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class EmailsRoutingModule {}
